module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-34.73d3225d.png";